import { lenis } from "./lenis";

export const getHeightReference = (ref, { signal = undefined } = {}) => {
  if (!ref.footer) return;

  const setHeight = () => {
    document.body.style.setProperty(
      "--footer-height",
      ref.footer[0].getBoundingClientRect().height + "px",
    );
  };

  setHeight();

  window.addEventListener("resize", setHeight, { signal });
};

export const moveLogoWhenInView = (ref) => {
  if (!ref.footer) return;

  const [footerElement] = ref.footer;

  const headerLogo = document.getElementById("header-logo");

  if (!headerLogo) return;

  let logoIsMoved = headerLogo.classList.contains("-translate-y-32");

  function move() {
    const { top } = footerElement.getBoundingClientRect();
    const isInView = top < window.innerHeight / 2;

    if (isInView && !logoIsMoved) {
      headerLogo.classList.add("-translate-y-32");
      logoIsMoved = true;
    }

    if (!isInView && logoIsMoved) {
      headerLogo.classList.remove("-translate-y-32");
      logoIsMoved = false;
    }
  }

  move();
  const teardown = lenis.on("scroll", move);

  return teardown;
};

export function spinLogoOnScroll(ref, { signal } = { signal: null }) {
  if (!ref.footerSpin) return;

  // let rotation = 0;

  // window.addEventListener(
  //   "wheel",
  //   (e) => {
  //     rotation += e.deltaY / 500;

  //     console.log(e.deltaY);
  //     ref.footerSpin[0].style.transition = `transform 100ms ease-out`;
  //     ref.footerSpin[0].style.transform = `scale(${Math.sin(rotation) * 0.1 + 0.9})`;
  //   },
  //   { signal },
  // );
}
